import type { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import { RequireAuth, RequireRole } from './lib/guards';
import { AppShell } from './components/AppShell';

import LandingPage from './pages/marketing/LandingPage';
import HowItWorksPage from './pages/marketing/HowItWorksPage';
import FaqPage from './pages/marketing/FaqPage';
import LoginPage from './pages/auth/LoginPage';

import DashboardPage from './pages/app/DashboardPage';
import PermitsListPage from './pages/app/PermitsListPage';
import NewPermitPage from './pages/app/NewPermitPage';
import PermitDetailPage from './pages/app/PermitDetailPage';
import IsolationPage from './pages/app/IsolationPage';
import TopologyPage from './pages/app/TopologyPage';
import BillingPage from './pages/app/BillingPage';
import AuditLogPage from './pages/app/AuditLogPage';
import AdminPage from './pages/app/AdminPage';
import NotFoundPage from './pages/NotFoundPage';

function Protected({ children }: { children: ReactNode }) {
  return (
    <RequireAuth>
      <AppShell>{children}</AppShell>
    </RequireAuth>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/how-it-works" element={<HowItWorksPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/login" element={<LoginPage />} />

      <Route path="/app" element={<Protected><DashboardPage /></Protected>} />
      <Route path="/app/permits" element={<Protected><PermitsListPage /></Protected>} />
      <Route
        path="/app/permits/new"
        element={
          <Protected>
            <RequireRole roles={['org_admin', 'safety_officer', 'area_authority', 'performing_authority', 'platform_admin']}>
              <NewPermitPage />
            </RequireRole>
          </Protected>
        }
      />
      <Route path="/app/permits/:permitId" element={<Protected><PermitDetailPage /></Protected>} />
      <Route path="/app/isolation" element={<Protected><IsolationPage /></Protected>} />
      <Route path="/app/topology" element={<Protected><TopologyPage /></Protected>} />
      <Route path="/app/billing" element={<Protected><BillingPage /></Protected>} />
      <Route
        path="/app/audit"
        element={
          <Protected>
            <RequireRole roles={['platform_admin', 'org_admin', 'safety_officer']}>
              <AuditLogPage />
            </RequireRole>
          </Protected>
        }
      />
      <Route
        path="/app/admin"
        element={
          <Protected>
            <RequireRole roles={['org_admin', 'platform_admin']}>
              <AdminPage />
            </RequireRole>
          </Protected>
        }
      />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
